
import * as React from 'react';
import InformationAlert from '../../../infrastructure/InformationAlert';

const RegisterInterestInformation = () => (
  <InformationAlert text='Your previously sent nature of interest' />
);

export default RegisterInterestInformation;